export default __webpack_public_path__ + "media/images/favicon/favicon-16x16-7d1783ff2b1d4013c0884acaf5224cb8.png";